/* Wizard · shared hooks
 *
 * iter98.99ai — Extracted the "settle-pulse" hook that was duplicated
 * inline in `RadioRailRow` and `ModeCard` so every selectable wizard
 * card can share the same 550ms scale + ring flash on the false→true
 * transition. Keeps the "locking-in" feedback consistent across all
 * six steps.
 */
import { useState, useEffect, useRef } from "react";

/* useSettlePulse(selected, ringClass?)
 *
 * Returns a `className` string that briefly applies a scale-up + colored
 * ring around the element the moment `selected` transitions from
 * false → true. Auto-clears after 550ms.
 *
 * The default ring is brand-primary. Pass a Tailwind ring color class
 * to match the accent of an individual card (violet, amber, etc.).
 *
 * Usage:
 *   const flash = useSettlePulse(selected);
 *   <button className={`...base... ${flash}`}>…</button>
 */
export function useSettlePulse(selected, ringClass = "ring-primary/30") {
    const [justPicked, setJustPicked] = useState(false);
    const prevRef = useRef(selected);
    useEffect(() => {
        if (!prevRef.current && selected) {
            setJustPicked(true);
            const t = setTimeout(() => setJustPicked(false), 550);
            prevRef.current = selected;
            return () => clearTimeout(t);
        }
        prevRef.current = selected;
    }, [selected]);
    return justPicked
        ? `scale-[1.02] ring-4 ${ringClass}`
        : "scale-100";
}
